import config from '@/config'
import routerFactory from 'firepuma-vue-axios-vuex-extensions/vue-router-factory/routerFactory';

import homeRoutes from '@/home/routes'

import dataAdminRoutes from '@/dataAdmin/routes'

import salesRoutes from '@/sales/routes'

// import broilerRoutes from '@/broiler/routes'
// import broilerAdminRoutes from '@/broilerAdmin/routes'

import layerRoutes from '@/layer/routes'
import layerAdminRoutes from '@/layerAdmin/routes'

import grazingRoutes from '@/grazing/routes'

import tenantRoutes from '@/tenant/routes'

import feedbackRoutes from '@/feedback/routes'

let routes = ([

]).concat(homeRoutes).concat([ //

]).concat(salesRoutes).concat([ //

]).concat(dataAdminRoutes).concat([ //

// ]).concat(broilerRoutes).concat([ //
// ]).concat(broilerAdminRoutes).concat([ //

]).concat(layerRoutes).concat([ //
]).concat(layerAdminRoutes).concat([ //

]).concat(grazingRoutes).concat([ //

]).concat(tenantRoutes).concat([ //

]).concat(feedbackRoutes).concat([

]);

let router = routerFactory({ appName: config.AppName, appRoutes: routes })

export const AllRoutes = routes;
export const Router = router;



// WEBPACK FOOTER //
// ./src/router.js